module.exports = __webpack_public_path__ + "static/media/AI_17.74cea8ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_17.png
// module id = 132
// module chunks = 0